import React, { useEffect, useState } from 'react'
import {Alert} from '@material-ui/lab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';


// const prettyBytes = require('pretty-bytes');

const axios = require('axios');

const publicUrl = process.env.REACT_APP_GOZ_PUBLIC_URL || '';
const backend = process.env.REACT_APP_GOZ_BACKEND_URL || publicUrl

const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
    editor: {
        minHeight: 800,
    },
    form: {
        margin: '10px'
    },
    dropzone: {
        backgroundColor: 'lightGrey',
    },
  });


export const Context = React.createContext();


const SharesBrowser = (props) => {

    const [shares, setShares] = useState([])
    const [tokens, setTokens] = useState([])
    const [errMsg, setErrMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [token, setToken] = useState(null)
    const [shareWith, setShareWith] = useState({
        path: '',
        user: '',
        group: '',
        mode: 'ro'
    })


    const classes = useStyles();


    const updateShares = () => {
        setLoading(true)
        axios.get(`${backend}/api/shares/`, {
            headers: {
                'Authorization': 'Bearer ' + props.token
            }
        }).then(resp => {
            setShares(resp.data.shares)
            setLoading(false)
        }).catch(err => {
            console.error('failed to get shares')
        })
        axios.get(`${backend}/api/tokens`, {
            headers: {
                'Authorization': 'Bearer ' + props.token
            }
        }).then(resp => {
            // console.debug('tokens', resp.data)
            setTokens(resp.data.tokens)
        }).catch(err => {
            console.error('failed to get tokens')
        })
    }

    const addShare = () => {
        if (shareWith.path === '') {
            setErrMsg('empty path')
            return
        }
        if (shareWith.user === '' && shareWith.group === '') {
            setErrMsg('both user and group are empty')
            return
        }
        let filter = {
            access: shareWith.mode,
        }
        if (shareWith.user !== '') {
            filter['user'] = shareWith.user
        }
        if (shareWith.group !== '') {
            filter['group'] = shareWith.group
        }
        axios.post(`${backend}/api/shares${shareWith.path}`,null, {
            headers: {
                'Authorization': 'Bearer ' + props.token
            },
            params: filter
        }).then(resp => {
            updateShares()
            setShareWith({
                path: '',
                user: '',
                group: '',
                mode: 'ro'
            })
            setErrMsg('')
        }).catch(err => {
            console.error('failed to delete share')
        })

        
    }

    const revokeToken = async (anontoken) => {
        axios.delete(`${backend}/api/auth/token`, {
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'X-Token': anontoken.Token
            }
        }).then(() => updateShares())
        .catch(err => console.error('failed to revoke token', err))
    }

    const removeShare = async (share) => {
        let filter = {}
        if (share.ToUser !== '') {
            filter['user'] = share.ToUser
        }
        if (share.ToGroup !== '') {
            filter['group'] = share.ToGroup
        }
        axios.delete(`${backend}/api/shares${share.Path}`, {
            headers: {
                'Authorization': 'Bearer ' + props.token
            },
            params: filter
        }).then(resp => {
            updateShares()
            setErrMsg('')
        }).catch(err => {
            console.error('failed to delete share')
        })
    }

    useEffect(() => {
        if(!props.token) {return}
        updateShares()
    }, [props.token])

    return (
        <React.Fragment>
        {errMsg && <Alert severity="error">{errMsg}</Alert>}
        {loading && <Alert severity="info">Loading...</Alert>}

        {props.token === null && <div>Please login first</div>}
        <h3>User shares</h3>

        {props.token !== null &&
        <Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="files">
                <TableHead>
                <TableRow>
                    <TableCell size="small">Path</TableCell>
                    <TableCell size="small">Shared with user</TableCell>
                    <TableCell size="small">Shared with group</TableCell>
                    <TableCell size="small">Write allowed?</TableCell>
                    <TableCell size="small"></TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <FormControl>
                            
                            <TextField variant="outlined" label="path" size="small" id="my-path" onChange={(e) => setShareWith({...shareWith, path: e.target.value})} value={shareWith.path}/>
                            </FormControl>
                        </TableCell>
                        <TableCell>
                            <FormControl>
                            <TextField variant="outlined" label="user" size="small"  id="my-user" onChange={(e) => setShareWith({...shareWith, user: e.target.value})} value={shareWith.user}/>
                            </FormControl>
                        </TableCell>
                        <TableCell>
                            <FormControl>
                            <TextField variant="outlined" label="group" size="small"  id="my-group" onChange={(e) => setShareWith({...shareWith, group: e.target.value})} value={shareWith.group}/>
                            </FormControl>
                        </TableCell>
                        <TableCell>
                            <FormControl className={classes.form}>
                                <InputLabel htmlFor="my-mode">Access</InputLabel>
                                <Select id="my-mode" onChange={(e) => setShareWith({...shareWith, mode: e.target.value})} value={shareWith.mode}>
                                <option value="ro">ro</option>
                                <option value="rw">rw</option>
                                </Select>
                            </FormControl>
                        </TableCell>
                        <TableCell>
                        <Button variant="contained" color="primary" onClick={()=>addShare()}>Add</Button>
                        </TableCell>
                    </TableRow>
                {shares.map((f, index) => (
                    <TableRow key={index}>
                    <TableCell>{f.Path}</TableCell>
                    <TableCell>{f.ToUser}</TableCell>
                    <TableCell>{f.ToGroup}</TableCell>
                    <TableCell>{f.WriteAllowed ? "yes": "no"}</TableCell>
                    <TableCell>
                    <Button variant="contained" color="primary" onClick={()=>removeShare(f)}>Remove</Button>
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
                </Table>
                </TableContainer>
            </Grid>
        </Grid>
        }

        <h3>Anonymous link tokens</h3>
        {props.token !== null &&
        <Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="files">
                <TableHead>
                <TableRow>
                    <TableCell size="small">Name</TableCell>
                    <TableCell size="small">Path</TableCell>
                    <TableCell size="small">Expires</TableCell>
                    <TableCell size="small">Access</TableCell>
                    <TableCell size="small"></TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {tokens.map((f, index) => (
                    <TableRow key={index}>
                    <TableCell>{f.Name}</TableCell>
                    <TableCell>{f.Path}</TableCell>
                    <TableCell>{new Date(f.Expires*1000).toLocaleDateString()}</TableCell>
                    <TableCell>{f.Rw ? "rw": "ro"}</TableCell>
                    <TableCell>{f.Revoked ? "revoked": <Button variant="contained" color="primary" onClick={() => revokeToken(f)}>Revoke</Button>}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
                </Table>
                </TableContainer>
            </Grid>
        </Grid>
        }
        </React.Fragment>
    )
}

export default SharesBrowser;